import { Identifier } from 'src/types/utilityTypes';
import api from 'src/utils/ajax';

import { Leaderboard } from './_types';
import {
  denormalizeLeaderboard,
  normalizeLeaderboard,
  normalizeLeaderboardList,
} from './normalizers';

interface FetchLeaderboardsOptions {
  page?: number;
  perPage?: number;
  search?: string;
  sortBy?: string;
  sortDir?: string;
}

interface FetchLeaderboardsResponse {
  leaderboard: Leaderboard[];
  meta: {
    total: number;
  };
}

export const fetchLeaderboardsQueryKey = (params: FetchLeaderboardsOptions) => {
  return ['leaderboards', params];
};

export const fetchLeaderboards = async ({
  page = 1,
  perPage = 20,
  search,
  sortBy,
  sortDir,
}: FetchLeaderboardsOptions = {}): Promise<FetchLeaderboardsResponse> => {
  const response = await api.get('/api/v4/leaderboards', {
    params: {
      page,
      per: perPage,
      'q[name_cont]': search,
      'q[s]': `${sortBy == 'createdAt' ? 'created_at' : sortBy} ${sortDir}`,
    },
  });

  return normalizeLeaderboardList(response.data);
};

export const fetchLeaderboard = async (
  id: Identifier
): Promise<Leaderboard> => {
  const response = await api.get(`/api/v4/leaderboards/${id}`);
  return normalizeLeaderboard(response.data);
};

export const createLeaderboard = async (
  leaderboard: Partial<Leaderboard>
): Promise<Leaderboard> => {
  const response = await api.post(
    '/api/v4/leaderboards',
    denormalizeLeaderboard(leaderboard)
  );
  return normalizeLeaderboard(response.data);
};

export const updateLeaderboard = async (
  id: Identifier,
  leaderboard: Partial<Leaderboard>
): Promise<Leaderboard> => {
  const response = await api.put(
    `/api/v4/leaderboards/${id}`,
    denormalizeLeaderboard(leaderboard)
  );
  return normalizeLeaderboard(response.data);
};

export const deleteLeaderboard = async (id: Identifier): Promise<void> => {
  await api.delete(`/api/v4/leaderboards/${id}`);
};
